export default __webpack_public_path__ + "static/media/Important.7c8d6270.svg";